<template>
  <section>
    <div class="area_pantalla">
    <div class="scroll_vertical">
    <div style="height: 22%"></div>

      <center>
        <div style="width: 77%; max-width: 400px">
          <img style="width: 80%; max-width: 300px" src="@/assets/logo_rackon2.svg" />

          <v-form v-if="mensaje_email_enviado==null" v-on:submit.prevent v-model="permitirEnviarLink">
            <div class="mt-10 text-h6" style="color: #bead87">Olvidé mi contraseña</div>
            <div class="mt-4">Introduzca su correo electrónico y le enviaremos un link para restablecer su contraseña</div>
            <v-text-field
              class="mt-7"
              ref="email"
              label="Correo electrónico"
              prepend-inner-icon="mdi-email"
              :rules="[rvValorNoVacio, rvEmailValido]"
              v-model="email"
              @keyup.enter="permitirEnviarLink && enviarLink()"
            ></v-text-field>

            <v-btn
              ref="entrar"
              :disabled="!permitirEnviarLink"
              elevation="2"
              style="mt-20"
              color="pink darken-4"
              @click="enviarLink()"
            >Enviar link</v-btn>
          </v-form>

          <v-container v-if="mensaje_email_enviado">
              <span class="mt-5 text-h9 white--text" v-html="mensaje_email_enviado"></span>
          </v-container>            

          <v-spacer></v-spacer>
          <div v-if="$global.deviceInfo.platform == 'web'" class="mt-5">
            <router-link to="/" replace>Iniciar sesión</router-link>
          </div>
        </div>
      </center>

    <div style="height: 40px"></div>
    </div>
    </div>
  </section>
</template>

<script>
import * as Validadores from '@/validadores.js'
import api from "@/api";


export default {
  name: "OlvideMiContrasena",
  data: () => ({
    mensaje_email_enviado: null,
    permitirEnviarLink: false,
    email: ""
  }),

  methods: {
    rvValorNoVacio (valor) { return Validadores.esValorNoVacio (valor) || 'Requerido' },
    rvEmailValido (valor) { return Validadores.esEmailValido (valor) || "Email no válido" },

    enviarLink () {
      this.mensaje_email_enviado = null;
      api.recuperarContrasena(this.email)
      .then (() => {
        })
      .catch(error => {
        console.log(error);
      })
      .finally(() => { 
          this.mensaje_email_enviado = "<br/>Se ha enviado un email de <span class='text-h7 green--text font-weight-bold'>recuperación de contraseña</span> al correo electrónico indicado <br/>";
      }) 
    }
  },

  mounted() {
    this.email = this.$route.query.email;
    if (this.email.trim()!="") {
      if (this.$global.deviceInfo.platform == "web")
        this.$refs.email.focus();
      }
    }
};
</script>

<style scoped>
.font-little * {
   font-size: 9px;
}
</style>